import template from './step-2.html';

class StepSecondComponent {
  /** @ngInject */
  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }
  }
}

export const StepSecond = {
  bindings: {
    me: '<'
  },
  template,
  controller: StepSecondComponent
};
